export default __webpack_public_path__ + "static/media/MainLandingPageHero.30b38078.png";